
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/debtreliefoasis",
      function () {
        return require("private-next-pages/debtreliefoasis/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/debtreliefoasis"])
      });
    }
  